import type { Router } from 'vue-router';

import { useAuthStore, type AuthContextLoadResult } from '@/entities/auth';

import { handleSessionExpired } from './use-session';

/**
 * Перечитывает auth-контекст без перезагрузки страницы, например после смены модулей или настроек.
 * Истёкшая сессия уходит штатному обработчику, контекст без организации — на выбор организации;
 * реакцию на сбой загрузки (тост, флаг повтора) оставляет себе страница.
 */
export const refreshAuthContext = async (router: Router): Promise<AuthContextLoadResult['status']> => {
  const result = await useAuthStore().loadContext();

  if (result.status === 'unauthenticated') {
    handleSessionExpired(router);
  } else if (result.status === 'organization-required') {
    await router.push({ name: 'auth.location-switch' });
  }

  return result.status;
};
